export default {
    getVoucher(state) {
        return state.voucher
    },
}


// WEBPACK FOOTER //
// ./assets/js/vue/store/getters/vouchersGetters.js